import { AnyBreakpoints, getValueForBreakpoint } from 'application/theme'
import React, { FC, useMemo } from 'react'
import { useTheme } from 'styled-components'

export type Props = {
  slidesPerPageProp: AnyBreakpoints<number> | number
  slidesPerGroupProp: AnyBreakpoints<number> | number
  activeGroupProp: AnyBreakpoints<number> | number
}

export const useGetPropsForBreakpoint = ({ slidesPerPageProp, slidesPerGroupProp, activeGroupProp }: Props) => {
  const theme = useTheme()
  const slidesPerGroup = useMemo(() => {
    if (typeof slidesPerGroupProp === 'number') {
      return slidesPerGroupProp
    } else {
      return getValueForBreakpoint(slidesPerGroupProp, theme.activeBreakpoint)
    }
  }, [theme.activeBreakpoint, slidesPerGroupProp])

  const slidesPerPage = useMemo(() => {
    if (typeof slidesPerPageProp === 'number') {
      return slidesPerPageProp
    } else {
      return getValueForBreakpoint(slidesPerPageProp, theme.activeBreakpoint)
    }
  }, [theme.activeBreakpoint, slidesPerPageProp])

  const activeGroup = useMemo(() => {
    if (typeof activeGroupProp === 'number') {
      return { value: activeGroupProp }
    } else {
      return { value: getValueForBreakpoint(activeGroupProp, theme.activeBreakpoint) }
    }
  }, [activeGroupProp, theme.activeBreakpoint])

  return { slidesPerGroup, slidesPerPage, activeGroup }
}
